import { createFileRoute } from '@tanstack/react-router';
import { JourneysWarehouseCreateHandoff } from '@/pages/workspaces/integrations/warehouse/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/integrations/warehouse/:type/sync` URL. The resolver is required:
 * ownership claims the `/workspaces/last` form, so the embedded app never mounts to resolve it.
 */
function JourneysWarehouseCreateRoute() {
  const { type } = Route.useParams();

  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysWarehouseCreateHandoff type={type} />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/$type_/sync',
)({
  component: JourneysWarehouseCreateRoute,
});
